import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaStar, FaBox, FaShieldAlt, FaDollarSign, FaUsers, FaTruck, FaWarehouse, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import './Home.css';

const Home = () => {
    const [services, setServices] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        fetchServices();
        fetchTestimonials();
    }, []);

    const fetchServices = async () => {
        try {
            const response = await axios.get('http://localhost:5000/api/services');
            setServices(response.data);
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    const fetchTestimonials = async () => {
        try {
            const response = await axios.get('http://localhost:5000/api/testimonials');
            setTestimonials(response.data);
        } catch (error) {
            console.error('Error fetching testimonials:', error);
        }
    };

    const serviceIcons = {
        home: <FaTruck />,
        office: <FaWarehouse />,
        box: <FaBox />,
        loading: <FaTruck />,
        unloading: <FaTruck />,
        truck: <FaTruck />
    };

    const serviceImages = [
        'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop',
        'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop',
        'https://images.unsplash.com/photo-1600518464441-9154a4dea21b?w=400&h=300&fit=crop',
        'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
        'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=400&h=300&fit=crop',
        'https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=400&h=300&fit=crop'
    ];

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % 1);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + 1) % 1);
    };
    const openWhatsApp = () => {
        const phoneNumber = '918189999775';
        const message = 'Hello, I would like to get a quote for your packers and movers service.';
        const url = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`;
        window.open(url, '_blank');
    }

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-slider">
                    <div className="hero-slide active" style={{
                        background: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("/Images/home_title.png") center/cover'
                    }}>
                        <div className="hero-content">
                            <h1>Reliable Packers and Movers You Can Trust</h1>
                            <p>From local shifting to long-distance relocation, Swastik Packers and Movers ensure smooth, affordable, and stress-free moving services.</p>
                        </div>
                    </div>
                    <button className="slider-btn prev" onClick={prevSlide}>‹</button>
                    <button className="slider-btn next" onClick={nextSlide}>›</button>
                </div>
            </section>

            {/* About Section */}
            <section className="about-section">
                <div className="container">
                    <div className="about-content">
                        <div className="about-text">
                            <span className="badge">ABOUT US</span>
                            <h2>Bk <span>Packers & Movers</span> Team</h2>
                            <p>Bk Packers & Movers is a premier relocation company with a legacy of trust and excellence. Founded in 2023, we have grown to become one of India's most reliable names in the packing and moving industry.</p>
                            <div className="features">
                                <div className="feature-item">
                                    <FaShieldAlt className="feature-icon" />
                                    <span>Licensed & Insured</span>
                                </div>
                                <div className="feature-item">
                                    <FaTruck className="feature-icon" />
                                    <span>Pan India Network</span>
                                </div>
                                <div className="feature-item">
                                    <FaUsers className="feature-icon" />
                                    <span>Trained Staff</span>
                                </div>
                                <div className="feature-item">
                                    <FaTruck className="feature-icon" />
                                    <span>GPS Tracking</span>
                                </div>
                            </div>
                        </div>
                        <div className="about-image">
                            <img src="/Images/Bk%20Packers%20%26%20Movers%20Team.png" alt="BK Team" loading="lazy" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose">
                <div className="container">
                    <div className="quote-button-top">
                        <button
  className="btn btn-primary"
  onClick={() =>
    window.open(
      "https://api.whatsapp.com/send/?phone=918189999775&text&type=phone_number&app_absent=0",
      "_blank"
    )
  }
>
  💡 Get Quote in 10 mins →
</button>
</div>
                    <div className="why-choose-content">
                        <div className="why-choose-left">
                            <div className="feature-box">
                                <FaBox className="feature-box-icon" />
                                <h3>Safe & Secure Packing</h3>
                                <p>Premium packing materials for complete protection</p>
                            </div>
                            <div className="feature-box">
                                <FaShieldAlt className="feature-box-icon" />
                                <h3>Damage-Free Moving</h3>
                                <p>Zero-damage guarantee on all relocations</p>
                            </div>
                            <div className="feature-box">
                                <FaDollarSign className="feature-box-icon" />
                                <h3>Affordable Relocation</h3>
                                <p>Competitive pricing without hidden charges</p>
                            </div>
                            <div className="feature-box">
                                <FaUsers className="feature-box-icon" />
                                <h3>Experienced Professionals</h3>
                                <p>Trained team with years of expertise</p>
                            </div>
                        </div>
                        <div className="why-choose-right">
                            <span className="badge-red">WHO WE ARE</span>
                            <h2 className="welcome-text">Welcome to</h2>
                            <h2 className="main-heading">BK Packers and Movers All Over India</h2>
                            <p className="description-text">
                                <span className="highlight">BK Packers and Movers - Chennai</span> are listed among the reputed packing and moving service provider in India offering services of Loading & Unloading, Car Transportation, Warehousing / Storage, Insurance, Relocation Service, Transportation and Packing & Unpacking.
                            </p>
                            <p className="description-text">
                                <span className="highlight">Packers and Movers in Chennai (BK Packers and Movers)</span> assure clarity in all aspects of the services and look forward for client's consent. Our list of satisfied client is a prime testimony to our dedicated services and customer-oriented approach.
                            </p>
                            <button className="btn btn-primary" onClick={() =>
    window.open(
      "https://api.whatsapp.com/send/?phone=918189999775&text&type=phone_number&app_absent=0",
      "_blank"
    )
  }>Learn More About Us →</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="services-section">
                <div className="container">
                    <div className="section-title">
                        <h2>Our <span>Services</span></h2>
                        <p>Reliable, safe & professional packing and moving solutions for every relocation need.</p>
                    </div>
                    <div className="services-grid">
                        <div className="service-card">
                            <img src="/Images/service-1.jpeg" alt="Home Relocation" loading="lazy" />
                            <div className="service-icon"><FaTruck /></div>
                            <h3>Home Relocation</h3>
                            <p>Safe and hassle-free household relocation with professional packing.</p>
                            <button className="btn btn-primary" onClick={()=>openWhatsApp()}>VIEW DETAILS</button>
                            <div className="service-underline"></div>
                        </div>
                        <div className="service-card">
                            <img src="/Images/service-2.jpeg" alt="Office Shifting" loading="lazy" />
                            <div className="service-icon"><FaWarehouse /></div>
                            <h3>Office Shifting</h3>
                            <p>Efficient office shifting with minimal downtime and maximum care.</p>
                            <button className="btn btn-primary" onClick={()=>openWhatsApp()}>VIEW DETAILS</button>
                            <div className="service-underline"></div>
                        </div>
                        <div className="service-card">
                            <img src="/Images/service-3.jpeg" alt="Packing and Unpacking" loading="lazy" />
                            <div className="service-icon"><FaBox /></div>
                            <h3>Packing and Unpacking</h3>
                            <p>Professional packing and unpacking services with quality materials.</p>
                            <button className="btn btn-primary" onClick={()=>openWhatsApp()}>VIEW DETAILS</button>
                            <div className="service-underline"></div>
                        </div>
                        <div className="service-card">
                            <img src="/Images/service-4.jpeg" alt="Loading" loading="lazy" />
                            <div className="service-icon"><FaTruck /></div>
                            <h3>Loading</h3>
                            <p>Safe and secure bike relocation with protective packaging.</p>
                            <button className="btn btn-primary" onClick={()=>openWhatsApp()}>VIEW DETAILS</button>
                            <div className="service-underline"></div>
                        </div>
                        <div className="service-card">
                            <img src="/Images/service-5.jpeg" alt="Unloading" loading="lazy" />
                            <div className="service-icon"><FaTruck /></div>
                            <h3>Unloading</h3>
                            <p>Damage-free vehicle transportation using special carriers.</p>
                            <button className="btn btn-primary" onClick={()=>openWhatsApp()}>VIEW DETAILS</button>
                            <div className="service-underline"></div>
                        </div>
                        <div className="service-card">
                            <img src="/Images/service-6.jpeg" alt="Transportation" loading="lazy" />
                            <div className="service-icon"><FaTruck /></div>
                            <h3>Transportation</h3>
                            <p>Secure and monitored storage solutions for short & long term.</p>
                            <button className="btn btn-primary" onClick={()=>openWhatsApp()}>VIEW DETAILS</button>
                            <div className="service-underline"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Work Process */}
            <section className="work-process">
                <div className="container">
                    <h2>Our Work Shifting Process.</h2>
                    <div className="process-steps">
                        <div className="step">
                            <div className="step-icon"><FaPhone /></div>
                            <h3>Request Quote</h3>
                            <p>Get instant estimates, compare services, analyze requirements, understand pricing, plan your move.</p>
                        </div>
                        <div className="arrow">→</div>
                        <div className="step">
                            <div className="step-icon"><FaBox /></div>
                            <h3>Schedule</h3>
                            <p>Book your slot, choose timing, confirm dates, approve survey, flexible scheduling options.</p>
                        </div>
                        <div className="arrow">→</div>
                        <div className="step">
                            <div className="step-icon"><FaTruck /></div>
                            <h3>Pack & Load</h3>
                            <p>Professional packaging, quality materials, careful handling, secure loading, inventory management.</p>
                        </div>
                        <div className="arrow">→</div>
                        <div className="step">
                            <div className="step-icon"><FaTruck /></div>
                            <h3>Deliver</h3>
                            <p>Real-time tracking, safe transit, timely delivery, unpacking assistance, complete satisfaction.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comparison Table */}
            <section className="comparison-section">
                <div className="container">
                    <h2>Why BK Packers and Movers is a Trusted Packers & Movers Brand</h2>
                    <table className="comparison-table">
                        <thead>
                            <tr>
                                <th>Service Features</th>
                                <th>Local Packers & Movers</th>
                                <th>BK Packers and Movers Packers & Movers</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Insured & Well-Maintained Vehicles</td>
                                <td><span className="check-green">✓</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Background Verified Drivers</td>
                                <td><span className="cross-red">✗</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Real Time Move Status Updates</td>
                                <td><span className="cross-red">✗</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Professional Packing & Unpacking Services</td>
                                <td><span className="check-green">✓</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Furniture Dismantling & Re-Assembly</td>
                                <td><span className="check-green">✓</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Trained Loading & Unloading Staff</td>
                                <td><span className="cross-red">✗</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Premium Bubble & Foam Protection</td>
                                <td><span className="cross-red">✗</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                            <tr>
                                <td>Secure On-Demand Warehouse Storage</td>
                                <td><span className="cross-red">✗</span></td>
                                <td><span className="check-green">✓</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            {/* Partner Logos */}
            <section className="partners-section">
                <div className="container">
                    <div className="partners-logos">
                        <img src="/Images/SBI_logo.png" alt="SBI" loading="lazy" />
                        <img src="/Images/quikr.png" alt="Quikr" loading="lazy" />
                        <img src="/Images/Sulekha_logo.png" alt="Sulekha" loading="lazy" />
                        <img src="/Images/deloitte_logo.png" alt="Deloitte" loading="lazy" />
                        <img src="/Images/mindtree_logo.png" alt="MindTree" loading="lazy" />
                        <img src="/Images/techmahindra_logo.png" alt="Tech Mahindra" loading="lazy" />
                        <img src="/Images/capgemini_logo.png" alt="Capgemini" loading="lazy" />
                        <img src="/Images/justdial_logo.png" alt="JustDial" loading="lazy" />
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="testimonials-section">
                <div className="container">
                    <div className="section-title">
                        <span className="badge">TESTIMONIAL</span>
                        <h2>What Our <span>Customers Say</span></h2>
                        <p>Don't just take our word for it. Here's what our satisfied customers have to say about their moving experience with Bk Packers and Movers.</p>
                        <div className="underline"></div>
                    </div>
                    <div className="testimonials-grid">
                        <div className="testimonial-card">
                            <div className="stars">
                                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                            </div>
                            <p>"Bk Packers and Movers made my house shifting completely hassle-free. The team was punctual, professional, and packed all items with great care. Highly recommended for safe relocation."</p>
                            <div className="customer-info">
                                <div className="avatar avatar-1">J</div>
                                <div>
                                    <h4>Jagan</h4>
                                    <span>Mumbai to Pune</span>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-card">
                            <div className="stars">
                                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                            </div>
                            <p>"Our office relocation was handled smoothly by Bk Packers and Movers. Their planning and coordination ensured zero downtime and safe movement of all office equipment."</p>
                            <div className="customer-info">
                                <div className="avatar avatar-2">S</div>
                                <div>
                                    <h4>Santhosh</h4>
                                    <span>Office Relocation - Chennai</span>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-card">
                            <div className="stars">
                                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                            </div>
                            <p>"Affordable pricing with excellent service quality. Bk Packers and Movers ensured timely delivery and safe handling of all my household items. Will surely use their service again."</p>
                            <div className="customer-info">
                                <div className="avatar avatar-3">S</div>
                                <div>
                                    <h4>Saran</h4>
                                    <span>Chennai to Hyderabad</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cta-button">
                        <button className="read-reviews-btn">
                            <span style={{ background: '#ffa500', width: '30px', height: '30px', borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '18px' }}>G</span> Read Customer Reviews
                        </button>
                    </div>
                </div>
            </section>

            {/* Achievements */}
            <section className="achievements-section">
                <div className="container">
                    <h2>Our Achievements</h2>
                    <div className="achievements-grid">
                        <div className="achievement-card">
                            <h3>3+</h3>
                            <p>YEARS OF EXPERIENCE</p>
                        </div>
                        <div className="achievement-card">
                            <h3>500+</h3>
                            <p>CLIENTS SERVED</p>
                        </div>
                        <div className="achievement-card">
                            <h3>700+</h3>
                            <p>SUCCESSFUL MOVES</p>
                        </div>
                        <div className="achievement-card">
                            <h3>100+</h3>
                            <p>CLIENT SATISFACTION</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section">
                <div className="container">
                    <div className="faq-content">
                        <div className="faq-image">
                            <img src="/Images/Bk%20Packers%20%26%20Movers%20Team.png" alt="FAQ" loading="lazy" />
                        </div>
                        <div className="faq-list">
                            <h2>Frequently asked questions</h2>
                            <p>Questions you might ask about us.</p>
                            <div className="faq-item">
                                <h3>How do I book your packers and movers service?</h3>
                                <p>You can easily book our service by calling us, filling out the online form, or requesting a free quote. Our team will schedule a survey and provide you with the best moving plan.</p>
                            </div>
                            <div className="faq-item">
                                <h3>What services do you provide?</h3>
                            </div>
                            <div className="faq-item">
                                <h3>How much do packers and movers charge?</h3>
                            </div>
                            <div className="faq-item">
                                <h3>Do you provide packing materials?</h3>
                            </div>
                            <div className="faq-item">
                                <h3>How long does it take to complete the shifting process?</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Google Reviews Section */}
            <section className="google-reviews-section">
                <div className="container">
                    <h2>Bk Packers & Movers <span>Google Reviews</span></h2>
                    <div className="google-reviews-grid">
                        <div className="google-review-card">
                            <div className="review-header">
                                <div className="reviewer-avatar"></div>
                                <div className="reviewer-info">
                                    <h4>Raju K</h4>
                                    <span>September 2025</span>
                                </div>
                                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png" alt="Google" loading="lazy" className="google-logo" />
                            </div>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>
                            <p>I booked for my bike shifting service from Bk packers and movers (Chennai to Bangalore) Their service was incredible. Saturday my bike was taken and Sunday morning 8 am I received my bike. Packing was perfect. Also, very reasonable price when compared to other movers. They respond to calls and messages correctly. Highly recommended.</p>
                            <button className="read-more-btn">Read More...</button>
                        </div>

                        <div className="google-review-card">
                            <div className="review-header">
                                <div className="reviewer-avatar"></div>
                                <div className="reviewer-info">
                                    <h4>karthika j nair</h4>
                                    <span>3 Months ago 2025</span>
                                </div>
                                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png" alt="Google" loading="lazy" className="google-logo" />
                            </div>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>
                            <p>I used like to move my household items from Chennai to Delhi. They were very good. The staff was friendly and helpful. They came on time to pack everything carefully. All my things like furniture, kitchen items, and clothes reached Delhi safely without any damage. The price was reasonable, and they told me the cost clearly from the start. Delivery was on the promised date. I am happy with their service and recommend them to anyone moving house. Good job!</p>
                            <button className="read-more-btn">Read More...</button>
                        </div>

                        <div className="google-review-card">
                            <div className="review-header">
                                <div className="reviewer-avatar"></div>
                                <div className="reviewer-info">
                                    <h4>Priyanka Mukherjee</h4>
                                    <span>August 2025</span>
                                </div>
                                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png" alt="Google" loading="lazy" className="google-logo" />
                            </div>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>
                            <p>Today I am moving my stuff from Chennai to Cuttac, Odisha Packaging was done great. Prompt service on time. Great job. Highly recommended. Expecting the delivery to be smoother.</p>
                            <button className="read-more-btn">Read More...</button>
                        </div>

                        <div className="google-review-card">
                            <div className="review-header">
                                <div className="reviewer-avatar"></div>
                                <div className="reviewer-info">
                                    <h4>Gokula Raman</h4>
                                    <span>August 2025</span>
                                </div>
                                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png" alt="Google" loading="lazy" className="google-logo" />
                            </div>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>
                            <p>Clean and Neat packing. Safe and Timely delivery. Highly recommended to others. Professional packers and movers.</p>
                            <button className="read-more-btn">Read More...</button>
                        </div>

                        <div className="google-review-card">
                            <div className="review-header">
                                <div className="reviewer-avatar"></div>
                                <div className="reviewer-info">
                                    <h4>Varsha G S</h4>
                                    <span>September 2025</span>
                                </div>
                                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png" alt="Google" loading="lazy" className="google-logo" />
                            </div>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>
                            <p>Best packers with low price... With good vehicle I moved locally into chennai. Clean & Quick service</p>
                            <button className="read-more-btn">Read More...</button>
                        </div>

                        <div className="google-review-card">
                            <div className="review-header">
                                <div className="reviewer-avatar"></div>
                                <div className="reviewer-info">
                                    <h4>Tharun Raviraj</h4>
                                    <span>December 2025</span>
                                </div>
                                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png" alt="Google" loading="lazy" className="google-logo" />
                            </div>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>
                            <p>The service was excellent. The movers had great packaging and even arrived 30 minutes early to pack everything very quickly and efficiently. They handled the delivery smoothly, easily bringing the items up to the third floor. The cost was reasonable, and highly recommend them for packing and moving.</p>
                            <button className="read-more-btn">Read More...</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;



